/**
 * Check if the new FTTS implementation should be used
 * @returns {boolean} true if new implementation should be used, false for old implementation
 */
export const isNewFttsImplementation = () => {
  // Check environment variable - defaults to false if not set
  const envFlag = process.env.REACT_APP_FTTS_SNMP_IMPLEMENTATION;

  // Convert string to boolean
  return envFlag === 'true' || envFlag === '1';
};

/**
 * Get the appropriate timestamp field based on implementation
 * @param {Object} alarm - The alarm object
 * @returns {string} The timestamp to display
 */
export const getAlarmTimestamp = (alarm) => {
  const isNewImplementation = isNewFttsImplementation();
  const isFttsTab = sessionStorage.getItem('selectedTab') === 'ftts';

  if (isFttsTab && isNewImplementation) {
    return alarm?.alarm_active_ts;
  } else {
    return alarm?.last_occurred;
  }
};

/**
 * Get the appropriate first occurred timestamp based on implementation
 * @param {Object} alarm - The alarm object
 * @returns {string} The first occurred timestamp
 */
export const getFirstOccurredTimestamp = (alarm) => {
  const isNewImplementation = isNewFttsImplementation();
  const isFttsTab = sessionStorage.getItem('selectedTab') === 'ftts';

  if (isFttsTab && isNewImplementation) {
    return alarm?.alarm_active_ts;
  } else {
    return alarm?.first_occurred;
  }
};

/**
 * Get the appropriate last occurred timestamp based on implementation
 * @param {Object} alarm - The alarm object
 * @returns {string} The last occurred timestamp
 */
export const getLastOccurredTimestamp = (alarm) => {
  const isNewImplementation = isNewFttsImplementation();
  const isFttsTab = sessionStorage.getItem('selectedTab') === 'ftts';

  if (isFttsTab && isNewImplementation) {
    return alarm?.alarm_inactive_ts;
  } else {
    return alarm?.last_occurred;
  }
};
